'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialValueSearchable = exports.getInitialValueMarketing = exports.loadSignupError = exports.signupWithFacebook = exports.signupWithEmail = exports.FORM_NAME = exports.messages = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.loadSignupData = loadSignupData;
exports.postSignupTracking = postSignupTracking;
exports.doSignupSubmission = doSignupSubmission;
exports.doFacebookSignup = doFacebookSignup;
exports.watchSignupSagas = watchSignupSagas;

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _reduxForm = require('redux-form');

var _effects = require('redux-saga/effects');

var _Consent = require('components/Consent/Consent.saga');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _apiErrorCodes = require('constants/api-error-codes');

var _Authentication = require('features/Login/Authentication.saga');

var _PhoneVerification = require('features/PhoneVerification/PhoneVerification.saga');

var _Products = require('features/Products/Products.helpers');

var _deep = require('helpers/deep');

var _forms = require('helpers/forms');

var _multitrack = require('helpers/multitrack');

var _optimizely = require('helpers/optimizely');

var _utmValues = require('helpers/utmValues');

var _helpers = require('redux/saga/helpers');

var _friendbuy = require('redux/saga/selectors/friendbuy');

var _locale = require('redux/modules/locale');

var _MixPanel = require('components/MixPanel/MixPanel');

var _request = require('redux/saga/selectors/request');

var _FormAction = require('./FormAction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadSignupData),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(postSignupTracking),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doSignupSubmission),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doFacebookSignup),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchSignupSagas);

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  errorCreatingAccount: {
    id: 'signup.error.unableToCreateAccount',
    defaultMessage: 'Sorry, we’re unable to create your account at this time. Please, <a href="{contact}">reach out to us</a> for account help.',
    values: {
      contact: '/contact'
    }
  },
  existingAccount: {
    id: 'signup.error.existingAccount',
    defaultMessage: 'Looks like you already started creating a ClassPass account with this email address in the past. Please <a href="{loginUrl}">log in</a> to complete your purchase.'
  },
  noFacebookEmail: {
    id: 'signup.error.noFacebookEmail',
    defaultMessage: 'Your Facebook account must have an email to sign up. Please add one or sign up via email.'
  },
  typoInEmail: {
    id: 'signup.error.typoInEmail',
    defaultMessage: 'Please check your email address for misspellings.'
  }
});

var FORM_NAME = exports.FORM_NAME = 'signup';

// Action names
var SIGNUP_WITH_FACEBOOK = 'SIGNUP.SIGNUP_WITH_FACEBOOK';
var LOAD_SIGNUP_DATA_ERROR = 'SIGNUP.LOAD_SIGNUP_DATA_ERROR';

// Actions
var signupWithEmail = exports.signupWithEmail = (0, _forms.augmentSubmitActionWithAdditionalData)(_FormAction.signup, { type: 'email' });
var signupWithFacebook = exports.signupWithFacebook = function signupWithFacebook() {
  return { type: SIGNUP_WITH_FACEBOOK };
};
var loadSignupError = exports.loadSignupError = _helpers.errorActionCreator.bind(null, LOAD_SIGNUP_DATA_ERROR);

// State selectors
var getInitialValueMarketing = exports.getInitialValueMarketing = (0, _forms.getFormFieldInitialValue)(FORM_NAME, 'marketing');
var getInitialValueSearchable = exports.getInitialValueSearchable = (0, _forms.getFormFieldInitialValue)(FORM_NAME, 'searchable');

function loadSignupData(client) {
  var consent, ActiveProduct;
  return _regenerator2.default.wrap(function loadSignupData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_Consent.loadAccountCreationConsent, client);

        case 3:
          consent = _context.sent;
          _context.next = 6;
          return (0, _effects.select)(_Products.getActiveProduct);

        case 6:
          ActiveProduct = _context.sent;
          _context.next = 9;
          return (0, _effects.all)([(0, _effects.put)((0, _reduxForm.initialize)(FORM_NAME, consent)), (0, _effects.put)((0, _reduxForm.change)(FORM_NAME, 'product', ActiveProduct.key)), (0, _effects.call)(ActiveProduct.loadSignupData, client), (0, _effects.spawn)(ActiveProduct.trackSignupLoad)]);

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](0);
          _context.next = 15;
          return (0, _effects.put)(loadSignupError(_context.t0));

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 11]]);
}

function postSignupTracking(signupType, profile, userId) {
  var gaEventName, locale;
  return _regenerator2.default.wrap(function postSignupTracking$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          gaEventName = signupType === 'facebook' ? 'Sign Up by Facebook' : 'Sign Up by Email';
          _context2.next = 3;
          return (0, _effects.select)(_locale.selectUserLocale);

        case 3:
          locale = _context2.sent;
          _context2.next = 6;
          return (0, _effects.all)([(0, _effects.call)(_MixPanel.mixpanel.alias, userId), (0, _effects.call)(_multitrack.ec, 'Create Account - Complete', {
            create_account_type: signupType,
            user_type: 'registered',
            email: profile.email,
            firstName: profile.first_name,
            gender: profile.gender,
            lastName: profile.last_name,
            locale: locale
            // TODO PV: test_branch: cohort.test_branch,
          }), (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'create_account'), (0, _effects.call)(_GoogleTagManager.trackGoogleTagManagerEvent, {
            event: 'account_created',
            email_address: profile.email,
            userId: userId
          }), (0, _effects.call)(_multitrack.ga, 'Membership Purchase', gaEventName, userId)]);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doSignupSubmission(client, _ref) {
  var formPayload = _ref.payload;

  var ActiveProduct, activeLocation, signupPayload, isEmailSignup, locale, initialValueMarketing, error, initialValueSearchable, userId, profile, phoneVerificationEnabled, nextStep, path, message, _path, loginUrl, errorObj, _error;

  return _regenerator2.default.wrap(function doSignupSubmission$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_Products.getActiveProduct);

        case 2:
          ActiveProduct = _context3.sent;
          _context3.next = 5;
          return (0, _effects.call)(_helpers.getUserLocation, client);

        case 5:
          activeLocation = _context3.sent;
          _context3.t0 = _extends3.default;
          _context3.next = 9;
          return (0, _effects.call)(_utmValues.getForApi);

        case 9:
          _context3.t1 = _context3.sent;
          _context3.t2 = [{
            legal_copy: formPayload.terms, // Terms is a required field in CMS so will always be defined
            action: { form_type: 'submit' },
            consent_type: ['terms_of_use', 'privacy_policy'],
            is_granted: true
          }];
          _context3.t3 = {
            conversion: _context3.t1,
            consents: _context3.t2
          };
          _context3.t4 = activeLocation && { gls_location_id: (0, _deep.deepExtract)('location.id', activeLocation) };
          signupPayload = (0, _context3.t0)(_context3.t3, _context3.t4);
          _context3.t5 = _extends3.default;
          _context3.t6 = {};
          _context3.t7 = signupPayload.conversion.utm;
          _context3.next = 19;
          return (0, _effects.select)(_friendbuy.friendbuyCode);

        case 19:
          _context3.t8 = _context3.sent;
          _context3.t9 = {
            utm_term: _context3.t8
          };
          signupPayload.conversion.utm = (0, _context3.t5)(_context3.t6, _context3.t7, _context3.t9);
          _context3.prev = 22;
          isEmailSignup = formPayload.type === 'email';
          _context3.next = 26;
          return (0, _effects.select)(_locale.selectUserLocale);

        case 26:
          locale = _context3.sent;

          if (!isEmailSignup) {
            _context3.next = 36;
            break;
          }

          (0, _assign2.default)(signupPayload, {
            user: {
              first_name: formPayload.firstName,
              last_name: formPayload.lastName,
              email: formPayload.email,
              password: formPayload.password,
              locale: locale
            },
            newsletter_subscribed: !!formPayload.marketing
          });

          // marketingDisclaimer is only shown to members in some countries

          if (!formPayload.marketingDisclaimer) {
            _context3.next = 34;
            break;
          }

          _context3.next = 32;
          return (0, _effects.select)(getInitialValueMarketing);

        case 32:
          initialValueMarketing = _context3.sent;

          signupPayload.consents.push({
            legal_copy: formPayload.marketingDisclaimer,
            action: {
              form_type: 'checkbox',
              form_default: initialValueMarketing ? 'checked' : 'unchecked'
            },
            consent_type: ['marketing_emails'],
            is_granted: signupPayload.newsletter_subscribed
          });

        case 34:
          _context3.next = 54;
          break;

        case 36:
          _context3.prev = 36;
          _context3.t10 = _assign2.default;
          _context3.t11 = signupPayload;
          _context3.next = 41;
          return (0, _effects.call)(_Authentication.authorizeFacebook);

        case 41:
          _context3.t12 = _context3.sent;
          _context3.t13 = {
            token: _context3.t12
          };
          _context3.t14 = {
            facebook: _context3.t13
          };
          (0, _context3.t10)(_context3.t11, _context3.t14);

          // facebookDisclaimer is only shown to members in some countries
          if (formPayload.facebookDisclaimer) {
            signupPayload.consents.push({
              legal_copy: formPayload.facebookDisclaimer,
              action: { form_type: 'submit' },
              consent_type: ['marketing_emails'],
              is_granted: true
            });
          }
          _context3.next = 54;
          break;

        case 48:
          _context3.prev = 48;
          _context3.t15 = _context3['catch'](36);
          error = new _reduxForm.SubmissionError({ _error: _context3.t15.message });
          _context3.next = 53;
          return (0, _effects.all)([(0, _effects.spawn)(ActiveProduct.trackSignupFailure), (0, _effects.put)((0, _reduxForm.stopSubmit)(FORM_NAME, error)), (0, _effects.put)(_FormAction.signup.failure(error))]);

        case 53:
          return _context3.abrupt('return');

        case 54:
          _context3.next = 56;
          return (0, _effects.select)(getInitialValueSearchable);

        case 56:
          initialValueSearchable = _context3.sent;

          signupPayload.consents.push({
            legal_copy: formPayload.searchableDisclaimer,
            action: {
              form_type: 'checkbox',
              form_default: initialValueSearchable ? 'checked' : 'unchecked'
            },
            consent_type: ['social_search'],
            is_granted: !!formPayload.searchable
          });

          _context3.next = 60;
          return (0, _effects.call)(ActiveProduct.submitSignupData, client, signupPayload);

        case 60:
          userId = _context3.sent;

          if (!isEmailSignup) {
            _context3.next = 65;
            break;
          }

          _context3.t16 = signupPayload.user;
          _context3.next = 68;
          break;

        case 65:
          _context3.next = 67;
          return (0, _effects.call)(_Authentication.getFacebookProfile, client && client.FB || window.FB);

        case 67:
          _context3.t16 = _context3.sent;

        case 68:
          profile = _context3.t16;
          _context3.next = 71;
          return (0, _effects.spawn)(ActiveProduct.trackSignupSuccess);

        case 71:
          _context3.next = 73;
          return (0, _effects.call)(postSignupTracking, formPayload.type, profile, userId);

        case 73:
          _context3.next = 75;
          return (0, _effects.call)(_PhoneVerification.userNeedsPhoneVerification, client);

        case 75:
          phoneVerificationEnabled = _context3.sent;
          nextStep = phoneVerificationEnabled ? 'verify-phone' : 'purchase';

          if (!phoneVerificationEnabled) {
            _context3.next = 80;
            break;
          }

          _context3.next = 80;
          return (0, _effects.put)((0, _reduxForm.change)('verify-phone-number', 'isNewUser', true));

        case 80:
          _context3.next = 82;
          return (0, _effects.put)(_FormAction.signup.success());

        case 82:
          _context3.next = 84;
          return (0, _effects.select)(_request.pathSelector);

        case 84:
          path = _context3.sent;
          _context3.next = 87;
          return (0, _effects.put)((0, _reactRouterRedux.push)(path.replace(/^\/signup/, '/' + nextStep)));

        case 87:
          _context3.next = 117;
          break;

        case 89:
          _context3.prev = 89;
          _context3.t17 = _context3['catch'](22);
          message = { _error: messages.errorCreatingAccount };

          if (!(formPayload.type === 'facebook' && _context3.t17.code === _apiErrorCodes.ERROR_SIGNUP_FB_EXISTING_ACCOUNT)) {
            _context3.next = 100;
            break;
          }

          _context3.next = 95;
          return (0, _effects.call)(_Authentication.doLoginWithFacebook, client, null, signupPayload.facebook.token);

        case 95:
          _context3.next = 97;
          return (0, _effects.call)(_helpers.gtmSafeRedirect, '/');

        case 97:
          return _context3.abrupt('return');

        case 100:
          if (!(_context3.t17.code === _apiErrorCodes.ERROR_SIGNUP_FB_MISSING_EMAIL)) {
            _context3.next = 104;
            break;
          }

          message = { _error: messages.noFacebookEmail };
          _context3.next = 113;
          break;

        case 104:
          if (!(_context3.t17.code === _apiErrorCodes.ERROR_SIGNUP_EXISTING_EMAIL)) {
            _context3.next = 112;
            break;
          }

          _context3.next = 107;
          return (0, _effects.select)(_request.pathSelector);

        case 107:
          _path = _context3.sent;
          loginUrl = '/login?returnTo=' + encodeURIComponent(_path);

          message = {
            _error: (0, _extends3.default)({}, messages.existingAccount, {
              values: {
                loginUrl: loginUrl
              }
            })
          };
          _context3.next = 113;
          break;

        case 112:
          if (_context3.t17.code === _apiErrorCodes.ERROR_INVALID_REQUEST) {
            message = { email: messages.typoInEmail };
          } else if (window.Rollbar) {
            window.Rollbar.error(_context3.t17);
          }

        case 113:
          errorObj = typeof message === 'string' ? { _error: message } : message;
          _error = new _reduxForm.SubmissionError(errorObj);
          _context3.next = 117;
          return (0, _effects.all)([(0, _effects.spawn)(ActiveProduct.trackSignupFailure), (0, _effects.call)(_helpers.scrollToTop), (0, _effects.put)(_FormAction.signup.failure(_error)), (0, _effects.put)((0, _reduxForm.stopSubmit)(FORM_NAME, errorObj))]);

        case 117:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[22, 89], [36, 48]]);
}

function doFacebookSignup(client) {
  return _regenerator2.default.wrap(function doFacebookSignup$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _reduxForm.startSubmit)(FORM_NAME));

        case 2:
          _context4.t0 = _effects.call;
          _context4.t1 = doSignupSubmission;
          _context4.t2 = client;
          _context4.t3 = _extends3.default;
          _context4.t4 = {
            type: 'facebook'
          };
          _context4.next = 9;
          return (0, _effects.select)((0, _forms.getFormValues)(FORM_NAME));

        case 9:
          _context4.t5 = _context4.sent;
          _context4.t6 = (0, _context4.t3)(_context4.t4, _context4.t5);
          _context4.t7 = {
            payload: _context4.t6
          };
          _context4.next = 14;
          return (0, _context4.t0)(_context4.t1, _context4.t2, _context4.t7);

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchSignupSagas(client) {
  return _regenerator2.default.wrap(function watchSignupSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, _FormAction.signup.REQUEST, doSignupSubmission, client);

        case 2:
          _context5.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, SIGNUP_WITH_FACEBOOK, doFacebookSignup, client);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}